export const TableSizeOptions = {
    "20": 20,
    "50": 50,
    "100": 100,
    "200": 200
}